import _ from 'lodash'
import { isNotUndefined } from '../helpers/types'
import {
  getChildImgAll,
  getChildManufacturer,
  getImgAll,
  getInstructionFiles,
  getModId,
  getModifierId,
  getModifiersValues,
  getModifiersValuesData,
  getSdsFiles,
} from '../helpers/Manufacturer/manufacturerCatalog'
import { isHavingProps } from '../helpers/object'
import { mapCategories } from '../helpers/category'
import { getFetchProductsInclude } from '../components/Manufacturer/Catalog/helper'
import noImage from '~/ZenOne-StoryBook/img/no-image.svg'
import noImageProduct from '~/ZenOne-StoryBook/img/no-image-product.svg'

export const status = {
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  ACTIVE: 'active',
  DISCONTINUED: 'discontinued',
  DELETED: 'deleted',
}

export const checkParamsForStatusDeletedFilter = (
  params,
  filters,
  isDownload = false
) => {
  const statusFilterValue =
    filters?.['filter[product.status]'] || filters?.['filter[status]']
  const isDeletedFilterActive =
    isNotUndefined(statusFilterValue) &&
    statusFilterValue.includes(status.DELETED)
  if (isDeletedFilterActive) {
    if (!isDownload) {
      params['filter[products.with-trashed]'] = true
    } else {
      params['filter[with-trashed]'] = true
    }
  } else if (!isDownload) {
    params['filter[products.with-trashed]'] = false
  } else {
    params['filter[with-trashed]'] = false
  }
  params.include = getFetchProductsInclude(isDeletedFilterActive)
  return params
}

export const statusList = [
  { id: 1, text: 'Draft', value: status.DRAFT },
  { id: 2, text: 'In Review', value: status.IN_REVIEW },
  { id: 3, text: 'Active', value: status.ACTIVE },
  { id: 4, text: 'Discontinued', value: status.DISCONTINUED },
  { id: 5, text: 'Deleted', value: status.DELETED },
]

// manufacturer-manage-library
export const sortTypes = {
  BY_PRODUCT_NAME: 'name',
  BY_PRICE: 'product.price',
}

export const getParentImage = (item) => {
  const isCatalog = item?.['products-with-trashed']?.data
  const productsProp = isNotUndefined(isCatalog)
    ? 'products-with-trashed'
    : 'products'
  const thumbPath =
    item?.[productsProp]?.data?.[0]?.images?.data?.[0]?.thumb?.data?.path
  if (isNotUndefined(thumbPath)) return thumbPath
  const imgPath = item?.[productsProp]?.data?.[0]?.images?.data?.[0]?.path
  if (isNotUndefined(imgPath)) return imgPath
}

export const getProduct = (el, products) => {
  if (
    el &&
    isHavingProps(el) &&
    products &&
    Array.isArray(products) &&
    products.length > 0
  ) {
    if (isNotUndefined(products?.[0])) {
      const productData = products[0]
      let imagesData = []
      const resultProductOnly = {
        ...productData,
        imgAll: [],
      }
      if (
        isNotUndefined(
          products?.[0]?.images?.data && products[0].images.data.length > 0
        )
      ) {
        imagesData = products[0].images.data
        if (imagesData && imagesData.length > 0) {
          return {
            ...resultProductOnly,
            imgAll: products[0].images.data,
          }
        } else {
          return resultProductOnly
        }
      } else {
        return resultProductOnly
      }
    } else {
      return null
    }
  }
  return null
}

export const mapProducts = (list = [], expand = false, selected = false) => {
  return list.reduce((acc, el) => {
    let children = []
    let productItem
    const products = el?.['products-with-trashed']?.data ?? el?.products?.data
    const status = products?.[0]?.status
    if (isNotUndefined(products) && isNotUndefined(status) && status !== null) {
      if (products.length > 1) {
        children = _.map(products, (childrenItem) => {
          const modId = getModId(el)
          const modifierValuesData = getModifiersValuesData(childrenItem, modId)

          let img = ''
          const productImg = childrenItem?.images?.data?.[0]?.path
          const noImageFlag = childrenItem?.noImage
          if (productImg) {
            img = productImg
          } else if (noImageFlag) {
            img = noImageProduct
          } else {
            img = noImage
          }

          return {
            'modifier-values': childrenItem['modifier-values'],
            genericNameModel: el.genericName,
            nameModel: el.name,
            id: childrenItem.id,
            genericName: childrenItem.genericName,
            parameters: childrenItem.parameters,
            description: childrenItem.description,
            packageQty: childrenItem.packageQty,
            packageMeasure: childrenItem.packageMeasure,
            sdsFiles: getSdsFiles(childrenItem),
            instructionFiles: getInstructionFiles(childrenItem),
            img,
            imgAll: getChildImgAll(childrenItem),
            name: childrenItem.name,
            package: childrenItem.packageQty,
            unit: childrenItem.packageMeasure,
            price: childrenItem.price,
            sku: childrenItem.sku,
            status: childrenItem.status,
            freeGood: null,
            manufacturer: getChildManufacturer(el),
            modifiers: childrenItem.modifiers,
            modifierValues: getModifiersValues(modifierValuesData),
            modifierId: getModifierId(modifierValuesData),
          }
        })
      }
      const inSelected = _.findIndex(
        selected,
        (f) => parseInt(el.id) === parseInt(f.id)
      )

      let img = ''
      const productImg = el?.products?.data?.[0]?.images?.data?.[0]?.path
      const noImageFlag = el?.products?.data?.[0]?.noImage
      if (productImg) {
        img = productImg
      } else if (noImageFlag) {
        img = noImageProduct
      } else {
        img = noImage
      }
      const { categoryList = [] } = el
      productItem = {
        id: el.id,
        expand: !!(expand && selected[0] && selected[0] === el.id),
        checked: inSelected > -1,
        imgAll: getImgAll(products),
        img,
        sdsFiles: getSdsFiles(products[0]),
        instructionFiles: getInstructionFiles(products[0]),
        name: products[0] ? products[0].name : null,
        nameGroup: el.name,
        product: getProduct(el, products),
        categoryId: el?.categoryId ?? null,
        manufacturer: el.manufacturer.data,
        sku: products[0] ? products[0].sku : null,
        package: products[0] ? products[0].packageQty : null,
        unit: products[0] ? products[0].packageMeasure : null,
        price: products[0] ? products[0].price : null,
        status: products[0] ? products[0].status : null,
        productId: products[0] ? products[0].id : null,
        modifiers: el.modifiers.data[0],
        productModelModifier: el['product-model-modifier']
          ? el['product-model-modifier'].data
          : null,
        children,
        ...mapCategories(categoryList),
        videoLink: el?.video_link ?? [''],
        otherInfo: el?.other_info ?? null,
        additionalDescription:
          products[0]?.parameters?.additionalDescription ?? '',
      }
      acc.push(productItem)
    }
    return acc
  }, [])
}
